var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbPreorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8385 18.0305H14.7008C13.8097 18.0305 13.2993 18.7191 13.5748 19.5697L15.114 24.4304C15.2436 24.8517 15.7135 25.2001 16.1753 25.2001H20.5742",
    stroke: "#80959D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6615 18.0305H25.7992C26.6904 18.0305 27.2007 18.7191 26.9253 19.5697L25.3861 24.4304C25.2564 24.8517 24.7866 25.2001 24.3248 25.2001H19.9258M17.3901 20.1125V23.1342M23.0934 20.1125V23.1342M20.2418 20.1125V23.1342M21.7486 18.2006H18.7268",
    stroke: "#80959D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5397 19.1969C17.1706 19.1969 17.682 18.6855 17.682 18.0546C17.682 17.4238 17.1706 16.9124 16.5397 16.9124C15.9089 16.9124 15.3975 17.4238 15.3975 18.0546C15.3975 18.6855 15.9089 19.1969 16.5397 19.1969Z",
    fill: "#80959D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9455 19.1969C24.5764 19.1969 25.0878 18.6855 25.0878 18.0546C25.0878 17.4238 24.5764 16.9124 23.9455 16.9124C23.3146 16.9124 22.8032 17.4238 22.8032 18.0546C22.8032 18.6855 23.3146 19.1969 23.9455 19.1969Z",
    fill: "#80959D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9787 14.4254L16.5889 17.8927M21.7251 14.4254L24.1149 17.8927",
    stroke: "#80959D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.123C18.75 8.77305 15.64 6.29305 11.85 6.02305C6.66996 5.66305 2.17996 9.56305 1.81996 14.743C1.52996 18.913 3.99996 22.633 7.67996 24.113C8.56996 24.473 9.52996 24.703 10.54 24.773",
    stroke: "#1557BF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16016 15.7731H10.6002V10.0731",
    stroke: "#1557BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbPreorderIcon);
export default __webpack_public_path__ + "static/media/RB_Preorder_icon.6c9d53850c762a468f1305a141512431.svg";
export { ForwardRef as ReactComponent };